import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash.isempty';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import moment from 'moment'
import {
  Grid, Button,
} from '@material-ui/core';
import { GetVacationOverview } from './vacationOverviewAction';
import OverLoader from '../../components/common/loader';
import { LogoutAction } from '../../actions';

const dateFormat = 'YYYY';

class OverviewPDF extends Component {

  state = {
    yearField: new Date().getFullYear(),

  }


  componentDidMount = () => {
    const { GetVacationOverview } = this.props
    const { yearField } = this.state
    GetVacationOverview(yearField)
  }

  yearFieldHandleChange = (e) => {
    const { GetVacationOverview } = this.props
    if (e !== null) {
      let date = moment(e._d).format("YYYY");
      this.setState({ yearField: date, consultant_pdf: '' }, () => GetVacationOverview(date))
    } else {
      this.setState({ yearField: '' })
    }
  }

  render() {
    const { yearField } = this.state
    const { isloading, vacation_overview } = this.props
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div className="plainingTab plainingTab-action">
        {isloading && <OverLoader />}
        <Fragment>
          <Grid container spacing={2}>
            <Grid item xs={2} className="inner-p-label">
              <div className="innermeLable">Jahr</div>
              <DatePicker
                value={yearField === "" ? '' : moment(yearField, dateFormat)}
                format={dateFormat}
                allowClear={false}
                bordered={false}
                onChange={(e) => {
                  this.yearFieldHandleChange(e)
                }}
                picker="year" />
            </Grid>
            {!isEmpty(vacation_overview) &&
              <Grid item xs={4} className="inner-p-label">
                {/* <a href={customerOverviewPdf} target="_blank"> */}
                <Button variant="outlined" color="primary"
                  onClick={() => {
                    const theLink = document.createElement('a');
                    theLink.href = vacation_overview;
                    theLink.download = "Urlaubsübersicht_" + yearField + ".xlsx";
                    document.body.appendChild(theLink);
                    theLink.click();
                    document.body.removeChild(theLink);
                  }
                  }
                >Drucken</Button>
                {/* </a> */}
              </Grid>
            }

          </Grid>
        </Fragment>
      </div>
    )
  }
}

const mapStateToProps = ({ VacationOverview }) => {
  return {
    vacation_overview: VacationOverview.vacation_overview,
    isloading: VacationOverview.loading,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetVacationOverview: (year) => dispatch(GetVacationOverview(year)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(OverviewPDF)